// extracted by mini-css-extract-plugin
module.exports = {"equationGrid":"CardKeyFiguresEquationGroup_equationGrid__hx2jy","gridItem":"CardKeyFiguresEquationGroup_gridItem__w_7Uc"};